import { Inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ScriptLoaderService, ScriptModel } from '@uzurv/clara';
import { Observable } from 'rxjs';
// eslint-disable-next-line import/order
import { AppConfiguration, APP_CONFIGURATION } from '../../app/app-configuration';

@Injectable()
export class MapsSdkResolver implements Resolve<Observable<ScriptModel>> {
  constructor(private scriptLoaderService: ScriptLoaderService, @Inject(APP_CONFIGURATION) private appConfiguration: AppConfiguration) {}

  resolve() {
    return this.scriptLoaderService.load({
      name: 'Maps SDK',
      src: `https://maps.googleapis.com/maps/api/js?key=${this.appConfiguration.googleMapsApiKey}&callback=Function.prototype&libraries=drawing,geometry,places`,
      loaded: false
    });
  }
}
